import MeridianModal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import React, { FC } from 'react';
import { Button, Text, TranslationFunction } from '../../../components/blocks/localization';

// Confirms the reseller means to discard the draft, since a discarded draft cannot be reviewed again.

export type PoReviewDiscardModalProps = {
    open: boolean;
    onCancel: () => void;
    onDiscard: () => void;
    t: TranslationFunction;
    dataTestId: string;
};

const PoReviewDiscardModal: FC<PoReviewDiscardModalProps> = ({ open, onCancel, onDiscard, t, dataTestId }) => {
    const describedById = `${dataTestId}.description`;

    return (
        <MeridianModal
            title={t('discardModal-title')}
            open={open}
            onClose={onCancel}
            scrollContainer={'viewport'}
            closeLabel={t('close-text')}
            describedById={describedById}
            bodySpacingInset={'medium'}
            data-testid={dataTestId}
        >
            <div id={describedById}>{open && <Text type={'b300'}>{t('discardModal-body-text')}</Text>}</div>
            {open && (
                <ModalFooter>
                    <Row alignmentHorizontal={'right'} widths={'fit'}>
                        <Button type={'secondary'} onClick={onCancel} data-testid={`${dataTestId}.cancelButton`}>
                            {t('discardModal-keepReviewing-buttonLabel')}
                        </Button>
                        <Button type={'primary'} onClick={onDiscard} data-testid={`${dataTestId}.discardButton`}>
                            {t('discardModal-confirm-buttonLabel')}
                        </Button>
                    </Row>
                </ModalFooter>
            )}
        </MeridianModal>
    );
};

export { PoReviewDiscardModal };
